import React from 'react';
import { CHANNEL_LIST } from '../channels';

/**
 * The per-page channel strip — the layout's channel dimension.
 *
 * Sits at the top of Brief / Activity / Create; the sidebar stays global.
 * Every registry channel renders a tab, connected or not, so a one-channel
 * user still SEES the product is multi-channel; an unconnected tab is
 * clickable and the page under it shows its connect state. Selection is
 * shared across pages via sessionStorage so switching Brief → Activity keeps
 * you on the same channel.
 */
const STORAGE_KEY = 'adpilot-active-channel';

export function readActiveChannel() {
  try {
    const requested = new URLSearchParams(window.location.search).get('channel');
    if (CHANNEL_LIST.some((channel) => channel.key === requested)) return requested;
    const stored = window.sessionStorage.getItem(STORAGE_KEY);
    return CHANNEL_LIST.some((channel) => channel.key === stored) ? stored : CHANNEL_LIST[0].key;
  } catch {
    return CHANNEL_LIST[0].key;
  }
}

function ChannelTabs({ active, onSelect, connectedKeys = null }) {
  const select = (key) => {
    try { window.sessionStorage.setItem(STORAGE_KEY, key); } catch { /* private mode */ }
    onSelect(key);
  };
  return (
    <div className="channel-tabs" role="tablist" aria-label="Ad channels">
      {CHANNEL_LIST.map((channel) => {
        const isActive = channel.key === active;
        const connected = connectedKeys === null || connectedKeys.has(channel.key);
        return (
          <button
            key={channel.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`channel-tab ${isActive ? 'channel-tab-active' : ''}`}
            onClick={() => select(channel.key)}
          >
            {channel.label}
            {!connected && <span className="channel-tab-dot" title="Not connected" aria-label="Not connected" />}
          </button>
        );
      })}
    </div>
  );
}

export default ChannelTabs;
